<template>
  <div class="ranking">
    <p class="title">{{title}}</p>
    <div class="rankingBox" v-if="firstList.length">
      <table class="first-table">
        <tbody class="first">
          <tr v-for="(team, index) in firstList" :key="index">
            <td class="info">
              <ul>
                <li>{{team.rank}}위</li>
                <li class="name">{{team.Player_name}}</li>
              </ul>
            </td>
            <td class="img" colspan="2">
              <img :src="team.img" alt="">
            </td>
            <td class="score" :class="{assist: title.includes('도움')}">
              <ul>
                <li>{{team.qty}}{{title.includes('득점') ? 'GOAL' : 'ASSIST'}}</li>
                <li class="game">{{team.work_qty}}GAME</li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody v-for="(team, index) in list" :key="index">
        <tr>
          <td class="rank" style="width: 10%">{{team.rank}}</td>
          <td class="name">{{team.Player_name}}</td>
          <td class="goal" style="width: 20%">{{team.qty}}{{title.includes('득점') ? '득점' : '도움'}}</td>
          <td class="game" style="width: 20%">{{team.work_qty}}경기</td>
        </tr>
        <tr v-if="list.length != index+1" class="line">
          <td class="space" colspan="5"></td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <p class="noData">데이터가 없습니다</p>
    </div>
  </div>
</template>

<script>
import {isEmpty} from '@/lib';
import dayjs from "dayjs";

export default {
  name: 'PlayerItem',
  props: {
    title: String,
    listData: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    listData: {
      handler: function () {
        if(!isEmpty(this.listData)) {
          this.init();
        }
      }
    }
  },
  data() {
    return {
      firstList: [],
      list: [],
    }
  },
  methods: {
    init() {
      const first = [];
      const etcList = [];

      Object.entries(this.listData).forEach(([, value]) => {
        if(value.rank === 1) {
          first.push(value);
        }else {
          etcList.push(value)
        }
      })

      this.firstList = first;
      const thisyear = dayjs().format('YYYY');
      this.firstList.map((item) => {
        item.img = `https://www.dragons.co.kr/resource/images/player/${thisyear}/${item.player_id}.png`;

      });
      // this.firstList[0].img = `https://www.dragons.co.kr/resource/images/player/${thisyear}/${this.firstList[0].player_id}.png`;
      this.list = etcList;
    }
  }
}
</script>
<style scoped>
.noData {
  text-align: center;
  padding: 50px 0;
  font-size: 16px;
  color: #999;
}
</style>
